import { Star } from '@sortlist-frontend/design-system/icons';
import { useTranslation } from '@sortlist-frontend/translation/ssr';
import { formatNumber } from '@sortlist-frontend/utils';

import { rankingConfig } from '../ranking.config';

interface RatingStatProps {
  rating: number | null;
  reviewCount: number;
  locale: string;
  isCompact?: boolean;
}

export const RatingStat = (props: RatingStatProps) => {
  const { rating, reviewCount, locale, isCompact = false } = props;
  const { t } = useTranslation(rankingConfig.i18nNamespaces);

  if (rating == null) {
    return <span className="text-secondary-500">{t('longtail:ranking.agency.noReviews')}</span>;
  }

  const reviews = isCompact ? `(${reviewCount})` : t('longtail:ranking.agency.reviews', { count: reviewCount });

  return (
    <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
      <Star size={14} className="fill-warning-500 text-warning-500" aria-hidden="true" />
      <span>
        <strong className="font-semibold text-secondary-950">
          {formatNumber({ value: rating, locale, minimumFractionDigits: 1, maximumFractionDigits: 2 })}
        </strong>
        {isCompact ? '' : t('longtail:ranking.agency.ratingOutOfFive')} {reviews}
      </span>
    </span>
  );
};
